import React from "react";
import { MyWritingDashboard } from "@/components/myWriting";

export default function MyWriting() {
  return <MyWritingDashboard />;
}
